import { useState } from 'react';

interface SliderInputProps {
  totalCount: number;
}

export const SliderInput = ({ totalCount }: SliderInputProps) => {
  const [value, setValue] = useState<number>(1);
  const numbers = Array.from({ length: totalCount }, (_, i) => i + 1);

  return (
    <div className="p-4 text-center">
      <input
        type="range"
        min="1"
        max={totalCount}
        value={value}
        onChange={(e) => setValue(Number(e.target.value))}
        className="w-full mb-2"
      />
      <div className="flex justify-between text-sm text-gray-600">
        {numbers.map((num) => (
          <span key={num}>{num}</span>
        ))}
      </div>
    </div>
  );
};
